import cx from 'classnames'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import './style.scss'

type Props = {
  id?: string
  className?: string
  defaultValue?: string
  placeholder?: string
  onSubmit: (keyword: string) => void
  onClear?: () => void
  showCancel?: boolean
}

export const SearchBox = ({
  id,
  className,
  defaultValue,
  placeholder,
  onSubmit,
  onClear,
  showCancel,
}: Props) => {
  const { t } = useTranslation()
  const [keyword, setKeyword] = useState(defaultValue)
  const [isFocus, setIsFocus] = useState(false)

  const onCancel = () => {
    setKeyword(defaultValue)
  }

  const isDirty = keyword !== defaultValue

  return (
    <form
      className="SearchBox"
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit(keyword)
      }}
    >
      <div className="SearchBox__input">
        <input
          id={id}
          className={cx('SearchBox__input__field', className)}
          placeholder={placeholder}
          type="text"
          name="keyword"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onFocus={() => setIsFocus(true)}
          onBlur={() => {
            setTimeout(() => {
              setIsFocus(false)
            }, 100)
          }}
        />
        {onClear && (keyword || isDirty) && (
          <div
            className="SearchBox__input__clear"
            onClick={() => {
              setKeyword('')
              onClear()
            }}
          />
        )}
      </div>
      {showCancel && (isFocus || isDirty) && (
        <div className="SearchBox__cancel" onClick={onCancel}>
          {t('common.cancel')}
        </div>
      )}
    </form>
  )
}
